
// CART DRAWER: On Cart Event "Updated" add the Gift products to the cart via ajax post request
//Adding Event Listener
document.addEventListener('cart:updated', function(event) {
    //Get the Cart variables to work with as well as gifts
    var cart = event.detail.cart;
    var cartTotal = cart.total_price;
    var $giftCartDataDiv = $('.gift-cart-data-js');
    var $giftCartDataDivs = $('.gift-cart-data-jss');
   
    //Function to hide or remove the Gift from the cart
    function hideOrRemoveProduct($element) {
        var productId = $element.attr('data');
        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                quantity: 0,
                id: productId
            },
            dataType: 'json',
            success: function(cart) {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
            },
        });
    }

    /**
     * Checks the total cart value against the limit for gift products and removes the gift products from the cart if the total is below the limit.
     * This function is called when the 'cart:updated' event is triggered, which indicates that the cart has been updated.
     */
    if ($giftCartDataDiv.length) {
        var limit = parseFloat($giftCartDataDiv.attr('limit'));
        if (cartTotal < limit) {
            hideOrRemoveProduct($giftCartDataDiv);
        }
    }
    // Check if there are multiple gift products and then remove them
    if ($giftCartDataDivs.length) {
        var limit = parseFloat($giftCartDataDivs.attr('limit'));
        if (cartTotal < limit) {
            hideOrRemoveProduct($giftCartDataDivs);
        }
    }
});



/**
 * Redirects the user to the home page if they are on the main cart page.
 * This function is executed when the document is ready.
 */
$(document).ready(function() {
  if($('.main_cart_page').length > 0) {
    window.location.href = '/';
  }
});






/** BENEFIT SECTION: text display on click for benifit section on home page
 * Initialisiert, dass in der Benefit-Section (Made in Germany usw.) Das erste Element standardmäßig geklickt ist
 * When the document is ready, this function performs the following actions:
 * - Triggers a click on the element with the class 'customstickyselect selected'
 * - Adds the 'current_tab' class to the first '.multi-column__item' element
 * - Shows the first '.content_hide' element and hides the last one
 * - Adds a click event listener to the '.multi-column__item' elements
 *   - When clicked, the current 'current_tab' class is removed from the active element
 *   - The clicked element is given the 'current_tab' class
 *   - All '.content_hide' elements are hidden
 *   - The '.content_hide' element at the same index as the clicked '.multi-column__item' is shown
 */
$(document).ready(function() {

$(".customstickyselect.selected").trigger("click");
  
    $('.multi-column__item:first').addClass('current_tab');
    $('.content_hide:first').show();
    $('.content_hide:last').hide();   
    $('.multi-column__item').on('click', function(){
        $('.multi-column__item.current_tab').removeClass('current_tab');
        $(this).addClass('current_tab');
        $('.content_hide').hide();
        var tabIndex = $(this).index();
        $('.content_hide').eq(tabIndex).toggle();
    });
});

//  Footer Menu dropdown for link one
$(document).ready(function() {
    $('.link_one').on('click', function(){
        $('.footer_custom_menu').slideToggle();
        if(!$(this).hasClass('active')) {
            $('.link_one').addClass('active');
           // $('.link_two').removeClass('active');
        } else {
            $(this).removeClass('active');
        }
    });

//  Footer Menu dropdown for link two  
    $('.link_two').on('click', function(){
        $('.footer_custom_menu_2').slideToggle();
        if(!$(this).hasClass('active')) {
            $('.link_two').addClass('active');
         //   $('.link_one').removeClass('active');
        } else {
            $(this).removeClass('active');
        }
    });
});


// Remove title attribute on hover of rating star
$(document).ready(function() {
   setTimeout(function () {
    $('.ruk_rating_snippet').hover(
        function() {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        },
        function() {
            $(this).attr('title', $(this).data('title'));
        }
    );
     }, 2000);
});



// Slick slider for Product page testimonials
$(document).ready(function(){
    $('.alltestimonia_slides').slick({
      autoplay: false,
      autoplaySpeed: 2000,
      slidesToShow: 1,
      dots: true,
      infinite:false,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
       responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
    });
  });  


// Remove empty space for review count inside bracket
$(document).ready(function() {
  $('.ruk-rating-snippet-count').each(function() {
    var text = $(this).text();
    var modifiedText = text.replace(/\(\s*(\d+)\s*\)/, '($1)');
    $(this).text(modifiedText);
  });
});


// Tabs for Product page 
/* This code sets up click event handlers for the tab links on the product page. 
 * When a tab link is clicked, it shows the corresponding tab content and hides the other tabs, and adds the 'active' class to the clicked tab link 
 * and removes it from the other tab links.
 */

// HIER müsste eigentlich die Preisberechnung initialisiert werden .customstickyselect sind die QD-Wechsler, aber die sind im Sale inaktiv

$(document).ready(function(){
  $('.tab-links a').on('click', function(e){
    var currentAttrValue = $(this).attr('href');
    $('.tabs ' + currentAttrValue).show().siblings().hide();
    $(this).parent('li').addClass('active').siblings().removeClass('active');
    e.preventDefault();
  });
});

// Individual discount bar color
/*This code Event listener updates the Quantity Discount Progress by expanding the width of the colored part of the bar

1. Retrieves the "forloop" attribute value of the clicked element and stores it in the "data2" variable.
2. Iterates over all elements with the class "quantity-item" and adds the "active" class to those with a "forloop" attribute value less than or equal to "data2", and removes the "active" class from the rest.
3. Retrieves the "totalblock" attribute value of an element with the class "get-data-block" and calculates the width of a progress line element with the class "qty-progress-line-aft" based on the "data2" value and the "totalblock" value.

*/
$(".quantity-item").click(function () {
    var data2 = parseInt($(this).attr("forloop"));
    $(".quantity-item").each(function () {
        var forloop = parseInt($(this).attr("forloop"));
        if (forloop <= data2) {
            $(this).addClass("active");
        } else {
            $(this).removeClass("active");
        }
    });
    var dataitem = $(".get-data-block").attr("totalblock");
    var datasinglewidth = 100 / dataitem;
    var netwidth = datasinglewidth * data2;
    $(".qty-progress-line-aft").width(netwidth + "%");
});


function calculateDiscount() {
  var currencySymbol = $('.bold_price').data('currency');
  var regularPrice = $('.discounted_price').data('variant_price')/100;
  // Get number of servings
  var portionValue = $('.bold_price').data('serving') || 1;
  // Get compare at Price
  var regularCutprice = $('.get_cut_price').data('ed-compare-price') / 100 || 0;
  console.log("Calculation ausgeführt")

  // Wenn Discount Text vorhanden ist, wird der Rabatt berechnet
  if ($('.discount-main-text').data('discount') === true ) {
      console.log("If1 angekommen")
      // Get Discount from the Discount Box text and format it as a percentage
      var rawDiscount = $('.discount-main-text').data('custom-discount').toString().replace('%', '');
      var customDiscountRate = parseFloat(rawDiscount) / 100;
      let discountedPrice, discountAmount;

      if ($('.get_cut_price').length > 0) {
          discountAmount = regularCutprice * customDiscountRate;
          discountedPrice = regularCutprice - discountAmount;
      } else {
          discountAmount = regularPrice * customDiscountRate;
          discountedPrice = regularPrice - discountAmount;
          console.log("discountedPrice: " + discountedPrice + "discountAmount: " + discountAmount + "customDiscountRate: " + customDiscountRate + "regularPrice: " + regularPrice + "portionValue: " + portionValue)
      }

      var totalDivide = discountedPrice / portionValue;

      // Update price elements

      //1. Discounted Price
      $('.discounted_price').text(discountedPrice.toFixed(2).replace('.', ',') + ' ' + currencySymbol);
      //2. Save Amount
      $('.hide_saveprice_subr .label--highlight .ed-save-amount').text(discountAmount.toFixed(2).replace('.', ',') + ' ' + currencySymbol);
      $('.hide_saveprice_subr').show();

      //3. Discounted Price per Serving
      $('.bold_price_serv').html(totalDivide.toFixed(2) + ' ' + currencySymbol);

      //4. KG-Preis
      var priceKG = $('.subscription_kg_price').data('kg');
      var Pricegram = (regularPrice / priceKG * 1000) * 100;
      var Pricegram = (discountedPrice / Pricegram) * 1000;
      console.log(Pricegram);
      var roundedGramPrice = Pricegram.toFixed(2).replace('.', ',');
      $(".subscription_kg_price").text(roundedGramPrice + ' ' + currencySymbol);



      console.log(totalDivide.toFixed(2) + ' ' + currencySymbol)
  } else {
      // Default calculation if no discount
      console.log("Else angekommen")
      var totalDivide = regularPrice / portionValue;
      $('.bold_price_serv').html(totalDivide.toFixed(2) + ' ' + currencySymbol);
  }
}



/** PDP: Discount bei Laden der Seite berechnen
 * Calculates the discounted price and updates the price elements on the page.
 * If the 'discount-main-text' element has a 'discount' data attribute set to true, the function calculates the discounted price and updates the relevant price elements.
 * If the 'discount-main-text' element does not have a 'discount' data attribute set to true, the function calculates the regular price and updates the relevant price elements.
 */
$(document).ready(function(){
  var currencySymbol = $('.bold_price').data('currency');
  var regularPrice = $('.bold_price').data('regular_price');
  var portionValue = $('.bold_price').data('serving');
  var regularCutprice = $('.get_cut_price').data('ed-compare-price')/ 100;
  if($('.discount-main-text').data('discount') === true) {
    $('.hide_saveprice_subr').append('<span class="test label label--highlight" data-product-label-list="">Du sparst <span class="ed-save-amount"></span></span>');
    
    calculateDiscount();
    
  } else {
    var totalDivide = regularPrice / portionValue;
    $('.bold_price_serv').html(totalDivide.toFixed(2) + ' ' + currencySymbol);
  }
});

/** PDP: ABO-Prozent Anzeige (Spare x% im Abo) 
 * Wert wird aus Loop-Element ausgelesen
 * Dann im Element mit der Klasse "save_amount" angezeigt
*/
$(document).ready(function(){
 var discountText = $('.loop-subscription-group-discount-badge').text();
        var discountValue = discountText.match(/\d+%/);
        if (discountValue) {
            var discountPercentage = parseFloat(discountValue[0]);
            $('.save_amount').text(discountValue[0]);
        }
});



// $(window).load(function(){
//   if (jQuery(".loop-selling-plan-selector").length > 0) {
//     $("input[name=selling_plan]").val(jQuery(".loop-selling-plan-selector").val())
//   }
// })


// Regular and save price for Subscription
/**
 * Handles the visibility of the regular price and save price elements for subscription and one-time plans.
 * When the 'loop_subscription_plan' is clicked, the '.regularPrice_subscription' and '.savePrice_subscription' elements are shown.
 * When the 'loop_one_time_plan' is clicked, the '.regularPrice_subscription' and '.savePrice_subscription' elements are shown if the 'discount-main-text' element has a 'discount' data attribute set to true, and the 'calculateDiscount()' function is called.
 */
$(document).ready(function() {
  $('.regularPrice_subscription, .savePrice_subscription').hide();
  $('.loop_subscription_plan').on('click', function() {
    $('.regularPrice_subscription, .savePrice_subscription').show();
    $('.hide_saveprice_subr').hide();
  });
  $('.loop_one_time_plan').on('click', function() {
     $('.hide_saveprice_subr').show();
    if($('.discount-main-text').data('discount') === true) {
      $('.regularPrice_subscription, .savePrice_subscription').hide();
      calculateDiscount();
    } else {
      $('.regularPrice_subscription, .savePrice_subscription').hide();
    }
  });
});


/** PDP: ABO-Box switched die Anzeige der Box je nachdem gewähltem Plan (Einzelkauf oder Abo)
 * Handles the visibility of the main price detail element based on the selected subscription or one-time plan.
 * When the 'loop_subscription_plan' is clicked, the 'main_price_detil' element is given the 'subscription_hide_price' class and the 'onetime_hide_price' class is removed.
 * When the 'loop_one_time_plan' is clicked, the 'main_price_detil' element is given the 'onetime_hide_price' class and the 'subscription_hide_price' class is removed.
 */
// 10-Oct-2024 Js
$(document).ready(function() {
   $('.main_price_detil').addClass('onetime_hide_price');
    $('.loop_subscription_plan').click(function() {
        $('.main_price_detil').addClass('subscription_hide_price').removeClass('onetime_hide_price');
    });
    $('.loop_one_time_plan').click(function() {
        $('.main_price_detil').addClass('onetime_hide_price').removeClass('subscription_hide_price');
    });
});


// Calculate the discount on click loop subscription tab
$(document).ready(function() {
    function updateDiscount() {

      var firstVariant = $('.variant_price').data('variant_price')/100;

      console.log("test1");
        var Portion = $('.loop_subscription_plan').data('per_portion');
       var currencySymbol = $('.customstickyselect').data('currency');
        var currencySymbol = $('.bold_price').data('currency');
      var currencySymbols = $('.variant_price').data('currency');
        var discountText = $('.loop-subscription-group-discount-badge').text();
        var discountValue = discountText.match(/\d+%/);
        if (discountValue) {
          console.log("test2");
            var discountPercentage = parseFloat(discountValue[0]);
            $('.save_amount').text(discountValue[0]);
            var subscriptionPrice = parseFloat($('.subscription_plan').data('subscription_price'));
            var discountedPrice = (subscriptionPrice / 100) * discountPercentage;
            var finalDiscount = subscriptionPrice - discountedPrice;
            $('.discounted_price').text(finalDiscount.toFixed(2).replace('.', ',') + ' ' + currencySymbol);
            console.log("test3");

          $('.regularPrice_subscription').text(firstVariant.toFixed(2).replace('.', ',') + ' ' + currencySymbol);

           var discount_cut_price = firstVariant - finalDiscount;
           $('.savePrice_subscription').text('Du sparst ' + discount_cut_price.toFixed(2).replace('.', ',') + ' ' + currencySymbol);
          
        }
       // kg price for subscription
        var price = $('.get_price').data('ed-price') / 100;
        var kgPrice = $('.subscription_kg_price').data('kg');
        var gramPrice = (price / kgPrice * 1000) * 100;
        var gramPrice = (finalDiscount / gramPrice) * 1000;
        console.log(gramPrice);
        var roundedGramPrice = gramPrice.toFixed(2).replace('.', ',');
        $(".subscription_kg_price").text(roundedGramPrice + ' ' + currencySymbol + '/kg');

        console.log("test4");
        var Portion_subacription = (finalDiscount / Portion);
        $('.bold_price_serv').text(Portion_subacription.toFixed(2) + ' ' + currencySymbol);
    }

    $('.subscription_plan').on('click', function() {
      console.log("test5");
        updateDiscount();
    });
});


/** PDP: QDs Updates the Per Portion Price for QDs
 * Updates the price display when the product variant changes.
 * Calculates the price per portion based on the selected quantity and the product's serving size.
 * Displays the calculated price per portion.
 */
$(document).on('variant:changed', function(event) {
    let variant = event.detail.variant;
    var qtys = $('.quantity-item.selected').attr('data-qty');
    $(".variant-price-c").attr("dataprice",variant.price);
    var perPortion = $('.bold_price').data('serving');
    var portionMAin = qtys * perPortion;
    var currencySymbol = $('.bold_price').data('currency');
    var portionDivide =  (variant.price / 100) / portionMAin;
    $('.bold_price_serv').text(portionDivide.toFixed(2) + ' ' + currencySymbol);
});

/** PDP: QDs - nicht verfügbar, 
 * customstickyselects existieren nicht, wenn Metafeld für QDs ausgeschaltet sind
 * - code calculates the discount for a one-time payment
 * - checks if the `.customstickyselect` element has the `selected` class
 * - then retrieves various data attributes to calculate the discounted price
 * - finally displays the discounted price
 */
// Calculate the discount of one time pay on product page
$(".customstickyselect").click(function(){
      if ($('.customstickyselect').hasClass('selected')){
        //var currencySymbol = $(this).data('currency');
         var currencySymbol = $('.bold_price').data('currency');
         console.log('====================='+ currencySymbol + '=================');
       var perPortion = $('.bold_price').data('serving');
         var variantPrice = $('.variant_price').data('variant_price')/ 100;
         var price = $('.get_price').data('ed-price')/ 100;
         var regularCutprice = $('.get_cut_price').data('ed-compare-price')/ 100;
         var savePrice = $('.get_save_price').data('product-label-list')/ 100;
         var kgPrice = $('.per_kg').data('kg');
         var quantity= $('.customstickyselect.selected').data('qty');
         var discount= $('.customstickyselect.selected').data("discount-value2");
        var dynamicDiscount= $('.customstickyselect.selected').data("disc");
        console.log('====================='+ dynamicDiscount + '=================');
        var discountss= $('.customstickyselect.selected').data("discount-value");

          if(discountss == ""){
           var subtotal_price = price * quantity;
           var formattedsubtotalPrice = currencySymbol + subtotal_price.toLocaleString('de-DE', { minimumFractionDigits: 2 }).replace('.', ',') ;
           //$(".get_price").html(formattedsubtotalPrice);

           

           //  alert(variantPrice);
                // var portionDivide =  variantPrice / perPortion;
                // $('.bold_price_serv').text(currencySymbol + portionDivide.toFixed(2));

            
         }
           else if(discount == dynamicDiscount){
               
            var subtotal_price =  price * quantity;
            var discount_amount = subtotal_price * 0.05;
            var discount_amount = Math.floor(discount_amount * 100) / 100;
            var discounted_price = subtotal_price - discount_amount;  
            var discounted_price = Number(discounted_price.toFixed(2));
            var formattedDiscountedPrice = currencySymbol +  discounted_price.toLocaleString('de-DE', { minimumFractionDigits: 2 }).replace('.', ',') ;
            // $(".get_price").html(formattedDiscountedPrice) ;


          
            //var totalBox =  perPortion;
             // alert(variantPrice);
            var portionDivide =  variantPrice / perPortion;
            $('.bold_price_serv').text("test");

              $(".per_kg").hide();
 
           } 

            
           else if (discount == dynamicDiscount){
            var subtotal_price = price * quantity;
            var discount_amount = subtotal_price * 0.10;  
            var discount_amount = Math.floor(discount_amount * 100) / 100;
            var discounted_price = subtotal_price - discount_amount;
            var discounted_price = Number(discounted_price.toFixed(2));
            var formattedDiscountedPrice = currencySymbol + discounted_price.toLocaleString('de-DE', { minimumFractionDigits: 2 }).replace('.', ',');
            // $(".get_price").html(formattedDiscountedPrice);

       

             
          // var totalBox =  perPortion;
            // alert(variantPrice);
            var portionDivide =  variantPrice / perPortion;
            $('.bold_price_serv').text(portionDivide.toFixed(2) + ' ' + currencySymbol);
              $(".per_kg").hide();   
          }
             
          else if (discount == dynamicDiscount){
            var subtotal_price = price * quantity;
            var discount_amount = subtotal_price * 0.15;  
            var discount_amount = Math.floor(discount_amount * 100) / 100;
            var discounted_price = subtotal_price - discount_amount;
            var discounted_price = Number(discounted_price.toFixed(2));
            var formattedDiscountedPrice = currencySymbol + discounted_price.toLocaleString('de-DE', { minimumFractionDigits: 2 }).replace('.', ',');
            // $(".get_price").html(formattedDiscountedPrice) ;  
           // var totalBox =  perPortion;
           // alert(variantPrice);
            var portionDivide =  variantPrice / perPortion;
            $('.bold_price_serv').text(portionDivide.toFixed(2) + ' ' + currencySymbol);
           //  $('.save_amount').text(discount);

              $(".per_kg").hide();

          
          }
            
            else{ 
            }
      } else{    
    } 
});

/** PDP: ABO-Box wechselt automatisch auf Variante 1, sodass dieses auch in den Cart geaddet wird
 * - trigger customtrigger1, dadurch wird die funktion unten ausgeführt und der select in der pdp geändert
 */
  $('.subscription_plan , .one_time_plan').on('click', function() {
    console.log('variante Zurück geändert');
      $(".block-1").trigger("click")
      $('.customtrigger1').click();
    var valueselling = jQuery(".product_tabs .loop-selling-plan-selector").val();
    // alert(valueselling)
    //   setTimeout(function(){
    //     if (jQuery(".loop-selling-plan-selector").length > 0) {
      
    //       var selects = $(".target-first-element .loop_duplicate:not(.loop-display-none) .loop-selling-plan-selector");
    
    // // Perform your desired actions on the selected elements
    // selects.each(function() {
    //     // Example action: log the id of each <select> element
    //     alert($(this).val());
    // });
         
    //     //  $("input[name=selling_plan]").val(jQuery(".loop-selling-plan-selector").val())
    //     }
    //   },200)
          
});

 
/** HEADER:
 * Adds a sticky header effect to the main header bar on the page.
 * 
 * When the user scrolls down the page past a certain threshold (70 pixels),
 * the `scrolled` class is added to the `.main_header_bar` element, which
 * can be used to apply styles for a sticky header.
 * 
 * The scroll position is also saved to the browser's localStorage, so that
 * the sticky header state is preserved across page loads.
 * 
 * A throttle function is used to limit the number of times the scroll event
 * handler is called, improving performance.
 */
$(document).ready(function() {
  var savedScrollPosition = localStorage.getItem('scrollPosition');
  if (savedScrollPosition !== null && parseInt(savedScrollPosition) > 70) {
    $('.main_header_bar').addClass('scrolled');
  }

  // Throttle Funktion ohne Bibliothek
  var throttle = function(callback, limit) {
    var wait = false;
    return function() {
      if (!wait) {
        callback.apply(this, arguments);
        wait = true;
        setTimeout(function() {
          wait = false;
        }, limit);
      }
    };
  };

  $(window).on('scroll', throttle(function() {
    var scrollTop = $(this).scrollTop();
    $('.main_header_bar').toggleClass('scrolled', scrollTop > 70);
    localStorage.setItem('scrollPosition', scrollTop);
  }, 200)); // Throttle auf alle 200ms setzen
});



// CART DRAWER: Add related product in the cart, when one of therecommendations at the bottom are selected
/**
 * Adds a related product to the cart when the ".custom_recoment_cart" element is clicked.
 * The variant ID of the product to be added is retrieved from the data-id attribute of the clicked element.
 * The product is added to the cart using an AJAX request, and a "cart:refresh" event is dispatched
 * to trigger a refresh of the cart.
 */
$(document).on("click", ".custom_recoment_cart", function() {
    var variantId = $(this).data('id');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: variantId
      },
      dataType: 'json',
      success: function(cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      },
      error: function(xhr, status, error) {
        console.error("Error adding product to cart:", error);
      }
    });
});


// PDP-QDs: Click variant (QD) when click One time purchase discount 

$('.customtrigger1').on('click', function() {
  
  $(".block-1").trigger("click")
  });
$('.customtrigger2').on('click', function() {
    $(".block-2").trigger("click")
  });
$('.customtrigger3').on('click', function() {
$(".block-3").trigger("click")
  });
$('.customtrigger4').on('click', function() {
    $(".block-4").trigger("click")
  });

  /*testen:
$('.customtrigger1, .customtrigger2, .customtrigger3, .customtrigger4').on('click', function() {
    var triggerClass = $(this).attr('class').match(/customtrigger(\d)/);
    if (triggerClass) {
        $(".block-" + triggerClass[1]).trigger("click");
    }
});

*/


/** PDP:
 * Toggles the visibility of the product sticky form based on the user's scroll position.
 * When the user scrolls less than 200 pixels from the top or less than 200 pixels from the bottom of the page,
 * the product sticky form is hidden. Otherwise, the form is displayed.
 */
$(document).ready(function() {
    $(window).on('scroll', function() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var documentHeight = $(document).height();

        if (scrollTop < 200 || (documentHeight - windowHeight - scrollTop) < 200) {
            $('.ed-product-sticky-form').attr('hidden', true);
        } else {
            $('.ed-product-sticky-form').removeAttr('hidden');
        }
    });
});


$(document).ready(function() {
    if (window.location.href.indexOf('daely-sleep') !== -1) {
        $(document).on('click', '.customstickyselect.selected', function() {
            $(".hide_kg_price").css("display", "none");
        });
    }
});


// If URL contains one of the specified strings, add the 'policy-pages' class to the body
// It is used because otherwise the "invisible header" used for the big image banners are eating up the page content for these policy pages
$(document).ready(function() {
    if (window.location.href.indexOf("versand") > -1) {
        $('body').addClass('policy-pages');
    }
   if (window.location.href.indexOf("365-tage-zufriedenheitsgarantie") > -1) {
        $('body').addClass('policy-pages');
    }
});


 /** FOOTER:
  *  Expands the submenu in Footer when heading is clicked
  * Handles the click event on elements with the class 'forst_link_nav'.
  * When clicked, it toggles the visibility of the submenu element.
  * If the submenu is already visible, it slides up. Otherwise, it slides down
  * and scrolls the page to the top of the clicked element plus the submenu height.
  */
 $(document).ready(function() {
      $('.forst_link_nav').click(function() {
          var $submenu = $(this).find('.submenu');
          if ($submenu.is(':visible')) {
              $submenu.slideUp();
          } else {
              $('.submenu').slideUp();
              $submenu.slideDown();
              var submenuHeight = $submenu.outerHeight();
              $('html, body').animate({
                  scrollTop: $(this).offset().top + submenuHeight
              }, 500);
          }
      });
  });

 
 /* Code is executed when document is ready
   + selects all h1 elements with the classes "heading" and "h2"
   + adds a "title" attribute to each element, setting the value to the text content of the element
  */
 $(document).ready(function(){
        // Select all h1 elements and add the attribute dynamically
        $('h1.heading.h2').each(function(){
            $(this).attr('title', $(this).text());
        });
    });